import { Eye, Edit3 } from "lucide-react";
import { Button } from '../../../../components/ui/Button';

export default function FormBuilderHeader() {
  return (
    <div className="bg-white rounded-lg border px-6 pt-5 pb-3 shadow-sm">
      <div className="flex items-center justify-between">
        <h2 className="text-[16px] font-bold text-black">
          Consultation Form Builder
        </h2>

        <div className="flex items-center gap-2">
          {/* Editor/Preview buttons removed as requested */}
        </div>
      </div>
    </div>
  );
}
